<script>
    import {ORDER_STATUS, ORDER_STATUSES, PAYMENT_METHOD} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import {formatDate} from "../lib/lib";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import OrderModal from "./OrderModal.svelte";

    let list = null;
    let total = 0;
    let page = 1;
    let selectedId = 0;
    let editId = null;

    let search = {
        limit: 50,
        offset: 0,
        date_from: '',
        date_to: '',
        term: null,
        code: null,
        payment_method: 'all',
        status_id: ORDER_STATUS.NEW,
    }

    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'ref_id', title: 'ΚΩΔΙΚΟΣ', sortable: true},
        {key: 'name', title: 'ΟΝΟΜΑ'},
        {key: 'phone_email', title: 'ΤΗΛΕΦΩΝΟ - EMAIL', class: 'hidden-xs'},
        {key: 'total_passports', title: 'ΔΙΑΒ.', class: 'hidden-xs'},
        {key: 'total_products', title: 'ΠΡ.', class: 'hidden-xs'},
        {key: 'total_price', title: 'ΠΟΣΟΝ', sortable: true, class: 'hidden-xs'},
        {key: 'created_at', title: 'ΗΜΕΡΟΜΗΝΙΑ', sortable: true, sort_way: 'DESC', class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    const load = () => {
        const onSuccess = result => {
            list = result.list;
            total = result.total;
            $app.passports_for_sync = result.passports_for_sync;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.order.index, search, onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = '';
        search.date_to = '';
        search.term = null;
        search.code = null;
        search.payment_method = 'all';
        search.status_id = ORDER_STATUS.NEW;
        page = 1;
        load();
    }

    const onShowOrderPassports = obj => {
        window.open(`/app/passports?order=${obj.ref_id}`, '_blank').focus();
    }

    const onEdit = obj => {
        selectedId = obj.id;
        editId = obj.id;
    }

    const onDelete = obj => {
        Alert.delete("Διαγραφή παραγγελίας", `Πρόκειται να διαγράψετε την παραγγελία "${obj.ref_id}".\nΘέλετε να συνεχίσετε;`, () => deleteOrder(obj.id));
    }

    const deleteOrder = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            Notifier.showMessage("Η παραγγελία διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Διαγραφή παραγγελίας", `Δεν μπορείτε να διαγράψετε αυτή την παραγγελία γιατί σχετίζεται με ${err.params.passports} διαβατήρια!`);
            }
        };

        R.handle(R.order.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const closeOrder = (param) => {
        editId = null;
        if (param) {
            load();
        }
    }

    load();
</script>

<PageHeader title="Παραγγελίες" controls={ pageHeaderControls } on:reload={ load }/>

<div class="panel panel-simple pb-2 mb-5">
    <div class="row row-condensed">
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">από</div>
                <input type="date" class="form-control" bind:value={ search.date_from } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">έως</div>
                <input type="date" class="form-control" bind:value={ search.date_to } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <select class="form-select" bind:value="{ search.status_id }" on:change={ onSearch }>
                <option value="all">κατάσταση</option>
                <option value="{ ORDER_STATUS.NEW }">Νέες παραγγελίες</option>
                <option value="{ ORDER_STATUS.ON_PROGRESS }">Σε εξέλιξη</option>
                <option value="{ ORDER_STATUS.SENT }">Απεσταλμένες</option>
                <option value="{ ORDER_STATUS.COMPLETED }">Ολοκληρωμένες</option>
                <option value="{ ORDER_STATUS.CANCELED }">Ακυρωμένες</option>
                <option value="{ ORDER_STATUS.RETURNED }">Επιστροφές</option>
                <option value="{ ORDER_STATUS.FAILED }">Αποτυχημένες</option>
                <!--                <option value="{ ORDER_STATUS.ON_PAYMENT }">Προς πληρωμή</option>-->
            </select>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <select class="form-select" bind:value="{ search.payment_method }" on:change={ onSearch }>
                <option value="all">πληρωμή με</option>
                <option value="{ PAYMENT_METHOD.CARD }">Κάρτα</option>
                <option value="{ PAYMENT_METHOD.COD }">Αντικαταβολή</option>
                <option value="{ PAYMENT_METHOD.BANK }">Κατάθεση</option>
            </select>
        </div>
        <div class="column-condensed col-xl-1 col-lg-4 col-md-3 pt-2">
            <input type="text" class="form-control" bind:value="{ search.code }" on:change={ onSearch }
                   placeholder="κωδικός">
        </div>
        <div class="column-condensed col-xl-3 col-lg-4 col-md-5 pt-2">
            <input type="text" class="form-control" bind:value="{ search.term }" on:change={ onSearch }
                   placeholder="όνομα τηλ. ή email">
        </div>
        <!--        <div class="hidden-xl hidden-lg col-md-8 hidden-sm hidden-xs"></div>-->
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4">
    <div class="col-xl-2 col-lg-3 col-md-4">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    <div class="col-xl-10 col-lg-9 col-md-8 hidden-xs">
        <div class="color-tips d-flex align-items-center">
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-1"></div>
                Νέα παραγγελία
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-2"></div>
                Σε εξέλιξη
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-3"></div>
                Απεσταλμένη
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-4"></div>
                Ολοκληρώθηκε
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-5"></div>
                Επιστράφηκε
            </div>
            <div class="color-tip d-flex align-items-center">
                <div class="color status-6"></div>
                Ακυρώθηκε / απέτυχε
            </div>
        </div>
    </div>
</div>

{#if list}
    {#if list.length}
        <table class="table table-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td class="ref-column">
                        <div class="status status-{ item.status_id}"></div>
                        { item.ref_id }
                        <div class="medium text-gray">
                            {#if item.payment_method == PAYMENT_METHOD.CARD}
                                { item.payment_id }
                            {:else if item.payment_method == PAYMENT_METHOD.COD}
                                Αντικαταβολή
                            {:else}
                                Κατάθεση
                            {/if}
                        </div>
                        {#if item.has_passports > 0}
                            <div class="passport" title="εμφάνιση διαβατηρίων" on:click={ () => onShowOrderPassports(item) }>
                                <AppIcon icon="passport"/>
                            </div>
                        {/if}
                    </td>
                    <td class="text-gray" title="{ ORDER_STATUSES[item.status_id] }">
                        <span class="is-link"
                              class:not-active="{ item.status_id == ORDER_STATUS.CANCELED || item.status_id == ORDER_STATUS.FAILED }"
                              on:click="{ () => onEdit(item) }">
                            { item.lastname } { item.firstname }
                        </span>
                    </td>
                    <td class="text-gray hidden-xs">
                        <div><a href="tel:{ item.phone }">{ item.phone }</a></div>
                        <div><a href="mailto:{ item.email }">{ item.email }</a></div>
                    </td>
                    <td class="products-column text-gray text-center hidden-xs">
                        {#if item.total_passports > 0}
                            { item.total_passports }
                        {/if}
                    </td>
                    <td class="products-column text-gray text-center hidden-xs">
                        { item.total_products }
                    </td>
                    <td class="price-column text-gray text-end hidden-xs">
                        { item.total_price }
                    </td>
                    <td class="datetime-column text-gray hidden-xs">
                        { formatDate(item.created_at, 'd-m-y H:i') }
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column pointer" title="διαγραφή παραγγελίας"
                            on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" { page }
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel panel-simple panel-pad">
            Δεν υπάρχουν παραγγελίες
        </div>
    {/if}
{/if}

{#if editId}
    <OrderModal orderId="{ editId }" closeCallback="{ closeOrder }"/>
{/if}

<style>
    .ref-column {
        position: relative;
        width: 100px;
    }

    .status {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background-color: #efefef;
    }

    .passport {
        position: absolute;
        left: -7px;
        top: 50%;
        transform: translateY(-50%);
        background: #fff;
        color: #333;
        padding: 2px;
        border-radius: 3px;
        cursor: pointer;
        /*top: 21px;*/
    }

    /* on payment */
    .status-0 {

    }

    /* new */
    .status-1 {
        border-right: 1px solid #efefef;
        background-color: #fff;
    }

    /* on progress */
    .status-2 {
        background-color: #03a9f4;
    }

    /* sent */
    .status-3 {
        background-color: #ffc107;
    }

    /* completed */
    .status-4 {
        background-color: #ff9800;
    }

    /* returned */
    .status-5 {
        background-color: #3f51b5;
    }

    /* canceled, failed */
    .status-6, .status-7 {
        background-color: #f44336;
    }

    .products-column {
        position: relative;
        width: 50px;
    }

    .color-tips .color-tip {
        line-height: 1;
    }

    .color-tips .color-tip .color {
        width: 12px;
        height: 12px;
        border: 1px solid #efefef;
        /*background: #ccc;*/
        margin-right: 5px;
    }

    .row-condensed {
        margin-left: 5px;
        margin-right: 5px;
    }

    .row-condensed .column-condensed {
        padding-left: 5px;
        padding-right: 5px;
    }
</style>